import { ROUTES } from 'settings/constants'

import { User } from 'types/app'

export interface MenuVisibilityContext {
  isLoggedIn: boolean
  user: User | null | undefined
}

export const hasLanQueueAccess = ({
  isLoggedIn,
  user,
}: MenuVisibilityContext): boolean =>
  isLoggedIn &&
  (user as (User & { lanQueueAccess?: boolean }) | null)?.lanQueueAccess ===
    true

export interface SideMenuItem {
  path: string
  label: string
  iconName: string
  isAuthRequired?: boolean
  children?: SideMenuItem[]
  isVisible?: (context: MenuVisibilityContext) => boolean
}

export const isSideMenuItemVisible = (
  item: SideMenuItem,
  context: MenuVisibilityContext,
): boolean =>
  (!item.isAuthRequired || context.isLoggedIn) &&
  (!item.isVisible || item.isVisible(context))

export const lanQueueMenuItem: SideMenuItem = {
  path: '/queue/play',
  label: 'Queue',
  iconName: 'game',
  isAuthRequired: true,
  isVisible: hasLanQueueAccess,
}

export const sideMenu: SideMenuItem[] = [
  {
    path: ROUTES.Hub,
    label: 'Hub',
    iconName: 'home',
    isAuthRequired: false,
  },
  {
    path: ROUTES.Explore,
    label: 'Explore',
    iconName: 'explore',
    isAuthRequired: false,
    children: [
      {
        path: ROUTES.Game,
        label: 'Games',
        iconName: 'game',
        isAuthRequired: false,
      },
      {
        path: ROUTES.Team,
        label: 'Teams',
        iconName: 'team',
        isAuthRequired: true,
      },
      {
        path: ROUTES.Community,
        label: 'Communities',
        iconName: 'group',
        isAuthRequired: false,
      },
      {
        path: ROUTES.StreamBrowse,
        label: 'Streams',
        iconName: 'video',
        isAuthRequired: false,
      },
    ],
  },
  {
    path: ROUTES.League,
    label: 'Leagues',
    iconName: 'league',
    isAuthRequired: false,
  },
  {
    path: ROUTES.Tournament,
    label: 'Tournaments',
    iconName: 'tournament',
    isAuthRequired: false,
  },
  {
    path: ROUTES.GameServers,
    label: 'Game Servers',
    iconName: 'server',
    isAuthRequired: true,
  },
  lanQueueMenuItem,
  {
    path: ROUTES.Profile,
    label: 'Profile',
    iconName: 'account',
    isAuthRequired: true,
  },
  {
    path: ROUTES.Notifications,
    label: 'Notifications',
    iconName: 'bell',
    isAuthRequired: true,
  },
  {
    path: ROUTES.Wallet,
    label: 'Wallet',
    iconName: 'wallet',
    isAuthRequired: true,
  },
  {
    path: ROUTES.Referrals,
    label: 'Referrals',
    iconName: 'gift',
    isAuthRequired: true,
  },
]

// Route prefixes that should expand the Explore parent in the sidebar.
// When the user is on any of these, the Explore children stay visible.
export const EXPLORE_ROUTE_PREFIXES: readonly string[] = [
  ROUTES.Explore,
  ROUTES.Game,        // /games
  '/game/',           // /game/:gameId
  ROUTES.Team,        // /teams
  '/team/',           // /team/:teamId
  ROUTES.Community,   // /community
  ROUTES.StreamBrowse,// /streams
  '/stream/',         // /stream/live/:username, /stream/dashboard
]

export const isExploreRoute = (pathname: string): boolean =>
  EXPLORE_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix),
  )
